module.exports = __webpack_public_path__ + "assets/cursormove.e64cd33e.svg";